import createContext from 'contexts/create-context';
import * as React from 'react';

import { type CustomerPortalCustomerEntry, useCustomerPortalCustomerById } from '../customer/models';
import { nullthrows } from '../../utils/invariant';
import { SpinnerBlock } from '../../components/Spinner';

export type Customer = NonNullable<CustomerPortalCustomerEntry>;

interface ProviderValue {
  customer: Customer;
  refreshData: () => void;
}

const [useContext, ReactProvider] = createContext<ProviderValue>();

interface ICustomerPortalCustomerProviderProps {
  customerId: number;
  children?: React.ReactNode;
}

export const CustomerPortalCustomerProvider: React.FC<ICustomerPortalCustomerProviderProps> = (props) => {
  const { children, customerId } = props;
  const { data, isLoading, mutate } = useCustomerPortalCustomerById(customerId);

  const refreshData = React.useCallback(() => {
    mutate();
  }, [mutate]);

  if (isLoading) {
    return <SpinnerBlock message="Loading..." className="h-screen" />;
  }

  const customer = nullthrows(data, 'customer not found');
  return <ReactProvider value={{ customer, refreshData }}>{children}</ReactProvider>;
};

export const useCustomerPortalCustomer = useContext;
